import { includes } from "lodash";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import RestrictedAccess from "../../../common/js/components/RestrictedAccess";
import DocumentAdminLanding from "./DocumentAdminLanding";
import operations from "./ducks/operations";

const DocumentAdminLandingContainer = (props) => {
    const { role } = props;

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/document-type", title: "Document Admin Landing" });
    }, []);

    if (includes(["dataAdmin"], role)) {
        return (
            <div>
                <DocumentAdminLanding {...props} />
            </div>
        );
    } else {
        return <RestrictedAccess />;
    }
};

const mapStateToProps = (state) => {
    return {
        columnToSort: state.stateDocumentRequirementsReducer.columnToSort,
        sortDirection: state.stateDocumentRequirementsReducer.sortDirection,
        role: state.authReducer.userProfile.role,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleSort: (columnName) => {
            dispatch(operations.handleSort(columnName));
        },
        handleSave: (parentTypes) => {
            dispatch(operations.saveProxyFlags(parentTypes));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentAdminLandingContainer);
